import React, { useEffect, useState } from 'react'
import { Dropdown, Modal, Nav, Tab } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import { customStyles } from '../Utility/Utility';
import { get_SliderData, get_SliderSingleData } from '../../../store/actions/CommanAction';
import { useDispatch, useSelector } from 'react-redux';
import swal from 'sweetalert';
import user from './../../../images/task/user.jpg';
import Loader from '../Loader/Loader';

const HomeSlider = () => {
    const dispatch = useDispatch()
    const SliderData = useSelector((state) => state.feedBackReducer.SliderData);
    const SliderSingleData = useSelector((state) => state.feedBackReducer.SliderSingleData);
    const customerID = Number(sessionStorage.getItem('ID'));

    const [HomePageslidersID, setHomePageslidersID] = useState('')
    const [IsActive, setIsActive] = useState(true);
    const [postModal, setPostModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [EditValue, setEditValue] = useState('')
    const [loading, setloading] = useState(false);
    const [Value, SetValue] = useState({
        'type': '', 'File': '', 'CreatedByUser': '1', 'imagesurl': '',
    });

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImageFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    useEffect(() => {
        if (IsActive) {
            dispatch(get_SliderData('1', setloading))
        } else {
            dispatch(get_SliderData('0', setloading))
        }
    }, [IsActive, IsActive]);


    const handleEditClick = (row) => {
        dispatch(get_SliderSingleData(row?.HomePageslidersID)); setHomePageslidersID(row?.HomePageslidersID); setEditModal(true);
    };

    useEffect(() => {
        if (SliderSingleData) {
            setEditValue(SliderSingleData);
        }
    }, [SliderSingleData]);

    useEffect(() => {
        setHomePageslidersID(HomePageslidersID); dispatch(get_SliderSingleData(HomePageslidersID));
        setEditValue(SliderSingleData);
    }, [HomePageslidersID])

    useEffect(() => {
        if (EditValue && EditValue.length > 0) {
            SetValue({
                ...Value,
                'HomePageslidersID': HomePageslidersID,
                'type': EditValue[0]?.type,
                'imagesurl': EditValue[0]?.imagesurl,
            });
        }
    }, [EditValue]);


    const AddType = [
        { value: 1, label: 'Web', },
        { value: 2, label: 'AppLogin', },
        { value: 3, label: 'Both', },
    ]

    const handleAddFormSubmit = async (e) => {
        e.preventDefault();
        if (Value.type === "") {
            swal('Oops!', 'Please fill out type', "warning");
            return;
        }
        if (!imageFile) {
            swal('Oops!', 'Please fill out img', "warning");
            return;
        }
        const formData = new FormData();
        formData.append('image', imageFile);
        formData.append('Data', JSON.stringify(Value));

        try {
            await AddUpdate('HomePagesliders/Insert_HomePagesliders', formData);
            swal('Good job!', 'Successfully Added', "success");
            setImageFile(null);
            setImagePreview(null);
            setPostModal(false);
            dispatch(get_SliderData(IsActive, setloading));
            Reset();
        } catch (error) {
            console.error("Error adding slider:", error);
            swal('Oops!', 'Something went wrong', "error");
        }
    };
    const UpdateSlider = async (e) => {
        e.preventDefault();
        if (Value.type === "") {
            swal('Warning!', 'Type field cannot be empty', 'warning');
            return;
        }
        const formData = new FormData();
        formData.append('image', imageFile);
        const editedContact = {
            type: Value.type,
            HomePageslidersID: HomePageslidersID,
        };
        formData.append('Data', JSON.stringify(editedContact));

        try {
            await AddUpdate('HomePagesliders/Update_HomePagesliders', formData);
            swal('Good job!', 'Successfully Updated', 'success');
            dispatch(get_SliderData(IsActive, setloading));
            setImageFile(null);
            setImagePreview(null);
            setPostModal(false);
            setEditModal(false);
        } catch (error) {
            console.error('Error adding slider:', error);
            swal('Oops!', 'Something went wrong', 'error');
        }
    };

    const Reset = () => {
        SetValue({ ...Value, 'type': '', 'File': '', });
        setImageFile(null); setImagePreview(null)
    }


    const columns = [
        {
            width: '500px',
            name: 'Slider Img',
            cell: row => (
                <img
                    src={row.imagesurl ? `https://${row.imagesurl.replace(/\\/g, "/")}` : 'default-image-url.jpg'}
                    alt="Slider"
                    style={{ width: '250px', height: 'auto', borderRadius: '4px' }}
                />
            ),
            sortable: true,
        },
        {
            name: 'Slider Type',
            selector: (row) => row.type,
            sortable: true,
        },
        {
            name: (
                <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>
            ),
            cell: row => (
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item onClick={() => handleEditClick(row)}>Edit</Dropdown.Item>
                            <Dropdown.Item className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.HomePageslidersID, true, '0');
                                }}
                            >
                                Inactive
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            ),
        }
    ];

    const columns1 = [
        {
            name: 'Slider Img',
            cell: row => (
                <img
                    src={row.imagesurl ? `https://${row.imagesurl.replace(/\\/g, "/")}` : 'default-image-url.jpg'}
                    alt="Slider"
                    style={{ width: '100px', height: 'auto', borderRadius: '4px' }}
                />
            ),
            sortable: true,
        },
        {
            name: 'Slider Type',
            selector: (row) => row.type,
            sortable: true,
        },
        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 0 }}>Action</p>,
            cell: row => <>
                <div style={{ position: 'absolute', top: 4, right: 5 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item
                                className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.HomePageslidersID, false, '1');
                                }}>
                                Active
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </>
        }
    ];

    const handleToggleStatusClick = async (HomePageslidersID, currentStatus, isActiveValue) => {
        const postData = {
            HomePageslidersID: HomePageslidersID,
            DeleteByUser: customerID,
            IsActive: isActiveValue,
        };
        await AddUpdate('HomePagesliders/Delete_HomePagesliders', postData);
        dispatch(get_SliderData(currentStatus ? '1' : '0', setloading))
        swal('Good job!', `Successfully ${isActiveValue === '1' ? 'Active' : 'Inactive'}`, "success");
    };



    return (
        <>
            <Tab.Container defaultActiveKey="All">
                <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
                    <div className="card-action coin-tabs mb-2">
                        <Nav as="ul" className="nav nav-tabs" role="tablist">
                            <Nav.Item as="li" className="nav-item">
                                <Nav.Link className="nav-link" eventKey="All" onClick={(currentStatus) => {
                                    setIsActive(true);
                                }} >Active</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                                <Nav.Link className="nav-link" eventKey="Inactive" onClick={(currentStatus) => {
                                    setIsActive(false);
                                }}>Inactive</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                    <Link to={"#"} className="btn btn-primary font-w600 mb-2" onClick={() => { setPostModal(true); Reset() }}>+ New Slider</Link>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <div className="">
                            <div className=" p-0">
                                <Tab.Content>
                                    <Tab.Pane eventKey="All">
                                        <div className="mb-sm-5 d-flex flex-wrap align-items-center text-head">

                                            <Modal className="modal fade" show={postModal} onHide={() => setPostModal(false)} backdrop="static">
                                                <form>
                                                    <div className="modal-header">
                                                        <h4 className="modal-title fs-20">Add Slider</h4>
                                                        <button type="button" className="btn-close" onClick={() => setPostModal(false)} data-dismiss="modal"></button>
                                                    </div>
                                                    <div className="modal-body p-3">
                                                        <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
                                                        <div className="add-contact-box">
                                                            <div className="add-contact-content">
                                                                <label htmlFor="image-upload" className="image-upload-label Slider-photo">
                                                                    <i className="flaticon-upload-icon"></i>
                                                                    {imagePreview ? (
                                                                        <img src={imagePreview} alt="Preview" className="image-preview" />
                                                                    ) : (
                                                                        <span>Upload Image</span>
                                                                    )}
                                                                </label>
                                                                <div className="">
                                                                    <input
                                                                        type="file"
                                                                        accept="image/*"
                                                                        onChange={handleImageChange}
                                                                        style={{ display: 'none' }}
                                                                        id="image-upload"
                                                                    />
                                                                </div>
                                                                <div className="form-group mt-2">
                                                                    <label className="form-label">Type</label>
                                                                    <span className="text-danger star-error" >*</span>
                                                                    <Select
                                                                        name='type'
                                                                        options={AddType}
                                                                        isClearable
                                                                        value={AddType.filter((obj) => obj.label === Value?.type)}
                                                                        onChange={(selectedOption) => {
                                                                            SetValue({ ...Value, ['type']: selectedOption ? selectedOption.label : '' });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button type="submit" className="btn btn-primary" onClick={handleAddFormSubmit}>Save</button>
                                                        <button type="button" onClick={() => { setPostModal(false); Reset(); }} className="btn btn-danger">
                                                            <i className="flaticon-delete-1"></i> Close
                                                        </button>
                                                    </div>
                                                </form>
                                            </Modal>
                                        </div>
                                        <Modal className="modal fade " show={editModal} onHide={setEditModal} backdrop="static">
                                            <div className="" role="document">
                                                <div className="">
                                                    <form >
                                                        <div className="modal-header">
                                                            <h4 className="modal-title fs-20">Edit Slider</h4>
                                                            <button type="button" className="btn-close" onClick={() => setEditModal(false)} data-dismiss="modal"></button>
                                                        </div>
                                                        <div className="modal-body p-3">
                                                            <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
                                                            <div className="add-contact-box">
                                                                <div className="add-contact-content">
                                                                    <div className="">
                                                                        <input
                                                                            type="file"
                                                                            accept="image/*"
                                                                            onChange={handleImageChange}
                                                                            style={{ display: 'none' }}
                                                                            id="image-upload"
                                                                        />
                                                                        <label htmlFor="image-upload" className="image-upload-label Slider-photo">
                                                                            <i className="flaticon-upload-icon"></i>
                                                                            {imagePreview ? (
                                                                                <img src={imagePreview} alt="Preview" className="image-preview" />
                                                                            ) : (
                                                                                <img
                                                                                    src={Value?.imagesurl ? `https://${Value?.imagesurl?.replace(/\\/g, '/')}` : 'default-image-url.jpg'}
                                                                                    alt="Preview"
                                                                                    className="image-preview"
                                                                                />
                                                                            )}
                                                                        </label>
                                                                    </div>

                                                                    <div className="form-group mt-2">
                                                                        <label className="form-label">Type</label>
                                                                        <span className="text-danger star-error" >*</span>
                                                                        <Select
                                                                            name='type'
                                                                            options={AddType}
                                                                            isClearable
                                                                            value={AddType.filter((obj) => obj.label === Value?.type)}
                                                                            onChange={(selectedOption) => {
                                                                                SetValue({ ...Value, ['type']: selectedOption ? selectedOption.label : '' });
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="modal-footer">
                                                            <button type="submit" className="btn btn-primary" onClick={UpdateSlider}>Update</button>
                                                            <button type="button" onClick={() => { setEditModal(false); Reset() }} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Close</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </Modal>
                                        <div className="col-12 mt-2">
                                            {loading ? (
                                                <Loader />
                                            ) : (
                                                <DataTable
                                                    dense
                                                    data={SliderData}
                                                    columns={columns}
                                                    selectableRowsHighlight
                                                    // highlightOnHover
                                                    pagination
                                                    onRowClicked={(row) => {
                                                        // setClickedRow(row);
                                                        // set_Edit_Value(row);
                                                    }}
                                                    // fixedHeader
                                                    persistTableHead={true}
                                                    noDataComponent={"There are no data to display"}
                                                    customStyles={customStyles}
                                                />)}
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="Inactive">
                                        <div className="row">
                                            <div className="col-12 mt-2">
                                                {loading ? (
                                                    <Loader />
                                                ) : (
                                                    <DataTable
                                                        dense
                                                        data={SliderData}
                                                        columns={columns1}
                                                        selectableRowsHighlight
                                                        highlightOnHover
                                                        pagination
                                                        onRowClicked={(row) => {
                                                        }}
                                                        fixedHeader
                                                        persistTableHead={true}
                                                        noDataComponent={"There are no data to display"}
                                                    />)}
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </div>
                </div >
            </Tab.Container >
        </>
    )
}

export default HomeSlider